import { bindActionCreators } from 'redux';

export default function wrapActionCreators(actionCreators) {
  return dispatch => bindActionCreators(actionCreators, dispatch);
}



// WEBPACK FOOTER //
// ./src/js/_libs/ng-redux/utils/wrapActionCreators.js